import React from "react";
import { CheckCircle2, Building2, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { schoolSteps, schoolImage } from "../mock";
import useReveal from "../hooks/useReveal";

export default function ForSchools() {
  const ref = useReveal();
  return (
    <section id="schools" ref={ref} className="bg-white py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-14 cc-reveal">
          <h2 className="font-head text-3xl md:text-4xl font-bold text-[#16244F] max-w-3xl mx-auto leading-snug">
            We help Schools build Career Counselling as a culture
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-[#F58220]" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="cc-reveal relative">
            <div className="absolute -top-5 -left-5 w-28 h-28 rounded-2xl bg-[#eaf3ff] -z-0" />
            <img
              src={schoolImage}
              alt="Career counselling session"
              className="relative z-10 rounded-2xl w-full h-[380px] object-cover cc-shadow-card"
            />
            <div className="absolute -bottom-5 -right-5 w-28 h-28 rounded-2xl bg-[#F58220]/15 -z-0" />
          </div>

          <div>
            <p className="text-[#5a6274] mb-8 cc-reveal">
              A structured career counselling guide for high school students includes the following steps:
            </p>
            <div className="space-y-5">
              {schoolSteps.map((st, i) => (
                <div
                  key={st.step}
                  className="cc-reveal flex gap-4 p-4 rounded-xl hover:bg-[#f6f8fc] transition-colors"
                  style={{ animationDelay: `${i * 0.1}s` }}
                >
                  <div className="shrink-0 mt-0.5 text-[#2b8cf0]">
                    <CheckCircle2 size={26} />
                  </div>
                  <div>
                    <div className="font-head font-semibold text-[#16244F]">
                      <span className="text-[#F58220]">{st.step}:</span> {st.title}
                    </div>
                    <p className="text-[15px] text-[#5a6274] mt-1">{st.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="cc-reveal mt-8 flex flex-wrap gap-3">
              <Link
                to="/school/register"
                data-testid="forschools-register-btn"
                className="inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold text-sm px-5 py-3 rounded-lg transition-colors"
              >
                <Building2 size={17} /> Register your School / College
              </Link>
              <Link
                to="/school/login"
                data-testid="forschools-login-btn"
                className="inline-flex items-center gap-2 border-2 border-[#16244F] text-[#16244F] hover:bg-[#16244F] hover:text-white font-head font-semibold text-sm px-5 py-3 rounded-lg transition-colors"
              >
                <LogIn size={17} /> School Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
